import { Divider, Grid, IconButton, Tooltip } from '@material-ui/core';
import * as userService from 'services/user';
import { SectionTitle, useCompanyFormState } from '../common';
import { blue } from '@material-ui/core/colors';
import { CompanyBasicFormField, CompanyQuotesPoliciesField } from '../fields';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockClosedIcon from '@material-ui/icons/Lock';
import Fab from '@material-ui/core/Fab';
import styled from 'styled-components';
import { VerifiedDetails } from './section-utils';
import { ExpandLessRounded, ExpandMoreRounded, InfoOutlined } from '@material-ui/icons';

const StyledFab = styled(Fab)`
  &.MuiFab-sizeSmall {
    width: 40px;
    // height: 30px;
  }
  & .MuiSvgIcon-root {
    font-size: 1.4rem;
  }
`;

export const PoliciesPracticesSection = () => {
  const { control } = useFormContext();
  const form = useFormContext();
  const { edit, company } = useCompanyFormState();
  const { user } = userService.useUser();
  const [isLock, setLock] = useState<boolean>(
    (company &&
      company.verified_sections &&
      company.verified_sections.policies_section &&
      company.verified_sections.policies_section.verified &&
      !edit) ||
      edit,
  );
  const watchOnVerifiedSections = form.watch('verified_sections');
  const verifiedBy =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.policies_section &&
    watchOnVerifiedSections.policies_section.verified_by;
  const verifiedAt =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.policies_section &&
    watchOnVerifiedSections.policies_section.verified_at + ' IST';
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const handleToggleExpand = () => {
    setIsExpanded(prev => !prev);
  };
  return (
    <>
      <Grid
        container
        spacing={2}
        justify="space-between"
        alignItems="center"
        onClick={handleToggleExpand}
        style={{
          cursor: 'pointer',
          userSelect: 'none',
          transition: 'background 0.2s ease',
        }}
        onMouseEnter={e => (e.currentTarget.style.background = '#f5f5f5')}
        onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}>
        <Grid item>
          <SectionTitle
            id="policies-practices"
            icon={<InfoOutlined fontSize="large" style={{ color: blue[600] }} />}
            title="Policies & Practices"
            subTitle="Policies and Practices Section"
          />
        </Grid>
        <Grid item style={{ paddingBottom: '10px', display: 'flex', alignItems: 'center', gap: 8 }}>
          <Tooltip
            title={
              isLock ? (
                <>
                  {`Verified by ${verifiedBy}`}
                  <br />
                  {`Verified at ${verifiedAt}`}
                </>
              ) : (
                'Click to Lock the Section'
              )
            }>
            {isLock ? (
              <StyledFab
                color="primary"
                aria-label="add"
                style={{ backgroundColor: 'green' }}
                size="small"
                onClick={e => {
                  e.stopPropagation();
                  setLock(false);
                  form.setValue('verified_sections', {
                    ...form.watch('verified_sections'),
                    policies_section: {
                      verified: false,
                      verified_by: null,
                      verified_at: null,
                      isLockApplied: false,
                    },
                  });
                }}>
                <LockClosedIcon />
              </StyledFab>
            ) : (
              <StyledFab
                color="primary"
                style={{ backgroundColor: 'red' }}
                aria-label="add"
                size="small"
                onClick={e => {
                  e.stopPropagation();
                  setLock(true);
                  form.setValue('verified_sections', {
                    ...form.watch('verified_sections'),
                    policies_section: {
                      verified: true,
                      verified_by: user.vtr_id,
                      verified_at: new Date().toLocaleString('en-US', { timeZone: 'IST' }),
                      isLockApplied: true,
                    },
                  });
                  // company.verified_sections.policies_section.verified_by = user.vtr_id;
                  // company.verified_sections.policies_section.verified = true;
                }}>
                <LockOpenIcon />
              </StyledFab>
            )}
          </Tooltip>
          {isLock && <VerifiedDetails verifiedBy={verifiedBy} verifiedAt={verifiedAt} />}
          {/* Expand / Collapse Button */}
          <Tooltip title={isExpanded ? 'Collapse section' : 'Expand section'}>
            <IconButton
              size="small"
              onClick={e => {
                e.stopPropagation();
                handleToggleExpand();
              }}>
              {isExpanded ? (
                <ExpandLessRounded color="primary" fontSize="large" />
              ) : (
                <ExpandMoreRounded color="primary" fontSize="large" />
              )}
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>

      <Divider />
      <br />
      <Grid container spacing={1} style={{ display: isExpanded ? 'flex' : 'none' }}>
        <fieldset disabled={isLock && edit} style={{ border: 'none' }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <CompanyBasicFormField
                name="security_practices"
                label="Security Practices"
                helperText="Add details relating to Security Practices"
                aria-readonly={true}
                rows="3"
                multiline
              />
              <br />
              <br />
            </Grid>
            <Grid item xs={12}>
              <CompanyBasicFormField
                name="diversity_and_inclusion"
                label="Diversity, Equity & Inclusion (DE&I)"
                helperText="Add details relating to diversity, Equity & Inclusion (DE&I)"
                aria-readonly={true}
                rows="3"
                multiline
              />
              <br />
              <br />
            </Grid>
            <Grid item xs={12}>
              <CompanyBasicFormField
                name="environment_sustainability_goals"
                label="Environmental Sustainability Goals"
                helperText="Add details relating to Environmental Sustainability Goals"
                aria-readonly={true}
                rows="3"
                multiline
              />
              <br />
              <br />
            </Grid>
            <Grid item xs={12}>
              <CompanyBasicFormField
                name="tax_credits_or_incentives"
                label="Tax Credits / Tax Incentives"
                helperText="Add details relating to Tax Credits / Tax Incentives"
                aria-readonly={true}
                rows="3"
                multiline
              />
              <br />
              <br />
            </Grid>
            <Grid item xs={12}>
              <CompanyBasicFormField
                name="commercial_model_and_pricing"
                label="Commercial Model & Rate Card"
                helperText="Add details relating to Commercial Model & Rate Card"
                aria-readonly={true}
                rows="3"
                multiline
              />
            </Grid>
          </Grid>
          <br />
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <CompanyQuotesPoliciesField
                control={control}
                name="quotes_policies"
                isLock={isLock}
              />
            </Grid>
          </Grid>
        </fieldset>
      </Grid>
    </>
  );
};
